import EmailDisplay from './Email'
import DoctorDisplay from './Doctor'
import Download from './Download'

export default {
    EmailDisplay,
    DoctorDisplay,
    Download
}
